import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { LegislationEmployeeCostSectionDTO } from "../../../../models/legislation-employee-cost-section/legislation-employee-cost-section-dto";
import {
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import EmployeeCostSectionConfigurationRow from "./EmployeeCostSectionConfigurationRow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import DialogTitle from "../../../DialogTitle/DialogTitle";
import { LegislationEmployeeCostSectionRef } from "../../../../models/legislation-employee-cost-section/legislation-employee-cost-section-ref";
import { LegislationSocialSecurityCostSectionRef } from "../../../../models/legislation-social-security-cost/legislation-social-security-cost-section-ref";
import { LegislationSocialSecurityCostDTO } from "../../../../models/legislation-social-security-cost/legislation-social-security-cost-dto";
import { LegislationRef } from "../../../../models/legislations";
import { StyledTableBody, StyledTableHead } from "../styles";
interface Props {
  legislation: LegislationRef;
  sections: LegislationEmployeeCostSectionRef[];
  socialSecurityConfig: LegislationSocialSecurityCostDTO | null;
}

const EmployeeCostSectionConfiguration = ({ sections }: Props) => {
  const tRP = "components.add_edit_legislation_employee_cost_section";
  const { t } = useTranslation();

  return (
    <>
      {sections.length > 0 ? (
        <Table stickyHeader>
          <StyledTableHead>
            <TableRow>
              <TableCell align="center">{`${t(`common_words.name`)}`}</TableCell>
              <TableCell align="center">{`${t(`${tRP}.fields.default_rate`)}`}</TableCell>
              <TableCell align="center">{`${t(`${tRP}.fields.fixed_amount`)}`}</TableCell>
              <TableCell align="center">{`${t(`${tRP}.fields.cap_amount`)} | ${t(
                `${tRP}.fields.min_amount`
              )}`}</TableCell>
              <TableCell align="center">{`${t(`${tRP}.fields.divided_by`)} | ${t(
                `${tRP}.fields.multiplied_by`
              )}`}</TableCell>
              <TableCell align="center">{`${t(`${tRP}.fields.contributes_to`)}`}</TableCell>
              <TableCell align="center">{`${t(`${tRP}.fields.proportional_to`)}`}</TableCell>
              <TableCell align="center">{`${t(`${tRP}.fields.consider_income_brackets`)}`}</TableCell>
            </TableRow>
          </StyledTableHead>
          <StyledTableBody>
            {sections.map((section) => (
              <EmployeeCostSectionConfigurationRow section={section} />
            ))}
          </StyledTableBody>
        </Table>
      ) : (
        <Typography>No sections set for this legislation</Typography>
      )}
    </>
  );
};
export default EmployeeCostSectionConfiguration;
